import { ref } from 'vue'
type sorterType = { field: string; order: BasicOrderType }[]
export default columns => {
  const orders = ref<BasicOrder[]>([])
  const _getOrderType = type => {
    return type === 'ascend' ? 'asc' : 'desc'
  }
  const _setDefaultOrder = () => {
    columns.forEach(item => {
      if (item.defaultSortOrder) {
        orders.value.push({ orderKeyName: item.dataIndex, orderType: _getOrderType(item.defaultSortOrder) })
      }
    })
  }
  const handleOrders = (sorter: sorterType) => {
    orders.value = sorter.length
      ? sorter.map(item => ({
          orderKeyName: item.field,
          orderType: _getOrderType(item.order)
        }))
      : []
  }
  const getOrders = () => {
    if (orders.value.length) {
      return orders.value
    }
  }
  _setDefaultOrder()
  return {
    handleOrders,
    getOrders
  }
}
